var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Material
import { Box, Tabs as MuiTabs } from "@mui/material";
import { COLORS } from "../../../constants";
// Say
import Tab from "../../Atoms/Tab";
import { tabsStyles } from "./Tabs.styles";
var Tabs = function (_a) {
    var tabs = _a.tabs, activeTab = _a.activeTab, _b = _a.isTitleTabs, isTitleTabs = _b === void 0 ? false : _b, sticky = _a.sticky, sx = _a.sx, clickHandler = _a.clickHandler, rest = __rest(_a, ["tabs", "activeTab", "isTitleTabs", "sticky", "sx", "clickHandler"]);
    var styles = tabsStyles(sticky, isTitleTabs);
    // pass new tab selected to parent component
    var onChange = function (_event, newValue) {
        clickHandler(newValue);
    };
    var mergedStyles = __assign(__assign({}, styles), sx);
    return (_jsxs(Box, __assign({ position: "relative" }, { children: [!isTitleTabs && (_jsx(Box, { height: "1px", bgcolor: COLORS.P_OUTLINE, width: "100%", position: "absolute", left: 0, bottom: 0 })), _jsx(MuiTabs, __assign({ sx: mergedStyles, value: activeTab, onChange: onChange, TabIndicatorProps: isTitleTabs ? { style: { display: "none" } } : {} }, rest, { children: tabs.map(function (tab) {
                    return _jsx(Tab, __assign({ isTitleTab: isTitleTabs }, tab), tab.value);
                }) }))] })));
};
export default Tabs;
